import { GET_FACILITY_FOR_HOLIDAY_SUCCESS, GET_FACILITY_FOR_HOLIDAY_FAILURE} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_FACILITY_FOR_HOLIDAY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_FACILITY_FOR_HOLIDAY_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
